module.exports = __webpack_public_path__ + "img/turkmenistan.5c778bb.webp";